<template>
  <div
    :id="id"
    :style="adquirirStylesOverlay"
    :class="adquirirClassesDeTipoOverlay"
    class="
      is-ava-global-loader
      is-flex
      is-justify-content-center
      is-align-content-center
      is-align-items-center
      is-flex-direction-column
    "
  >
    <img src="../../assets/img/ava/ava_carregamento_branco_100px.gif" alt="AVA - Carregando"/>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "AVALoader",
  props: {
    id: String,
    type: {
      type: [String],
      required: false,
      default: "fixed",
    },
    zIndex: {
      type: [String],
      required: false,
      default: "11",
    },
    textoDeStatus: {
      type: [String],
      required: false,
      default: "",
    },
  },
  computed: {
    adquirirClassesDeTipoOverlay() {
      if (this.type == "overlay") {
        return "is-overlay";
      } else {
        return "is-trf-fixed";
      }
    },
    adquirirStylesOverlay() {
      const styles = `z-index: ${this.zIndex};background: #FFF;`;
      return styles;
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
.is-trf-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
</style>
